import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  viewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize, first } from "rxjs/operators";
import {
  CONFIRM_DIALOG_AREA_DELETE,
  CONFIRM_DIALOG_CONFIRM_ACTION,
  ProductCategoriesAttributes,
} from "../../locale/consts.en";
import { ItemEditComponent } from "../item-edit/item-edit.component";
import { MasterDataService } from "../master-data/master-data-service";
import { Area, Branch } from "../master-data/master-data.model";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { sortByStringWithEmptyAtEnd } from "../shared/helpers/helper-functions";
import { BranchEditDialogComponent } from "./branch-edit-dialog/branch-edit-dialog.component";
import { BranchesAreasEditComponent } from "./branches-areas-edit/branches-areas-edit.component";
import { BranchesService } from "./branches.service";

@Component({
  selector: "app-branches",
  templateUrl: "./branches.component.html",
  styleUrls: ["./branches.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BranchesComponent implements OnInit, AfterViewInit {
  private branchesService = inject(BranchesService);
  private masterDataService = inject(MasterDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  dialog = inject(MatDialog);

  readonly sort = viewChild(MatSort);
  dataSource: MatTableDataSource<Branch>;
  displayedColumns: string[] = ["name", "externalId", "areas", "add", "edit"];

  branches: Branch[] = [];
  areas: Area[] = [];

  ngOnInit(): void {
    const branches = this.route.snapshot.data.branches ?? [];
    this.branches = sortByStringWithEmptyAtEnd(branches, (item) => item.name);
    // this.branches = this.route.snapshot.data.branches.sort((a, b) =>
    //   a.name.localeCompare(b.name)
    // );
    this.dataSource = new MatTableDataSource(this.branches);
    this.masterDataService.getAreas().subscribe({
      next: (ars) => {
        this.areas = ars;
      },
      complete: () => {
        console.log("GET AREAS COMPLETE!");
      },
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onBack() {
    this.router.navigate(["/"]).then();
  }

  saveBranchToApi(branch: Branch) {
    this.branchesService
      .updateBranch(branch)
      .pipe(
        finalize(() => {
          this.branchesService
            .getAllBranches()
            .pipe(first())
            .subscribe((branches) => {
              this.branches = sortByStringWithEmptyAtEnd(
                branches,
                (item) => item.name,
              );
              // this.branches = branches.sort((a, b) =>
              //   a.name.localeCompare(b.name)
              // );
              this.dataSource.data = this.branches;
            });
        }),
      )
      .subscribe({
        next: (response) => {
          this.branchesService.handleResponse(response);
        },
        error: () => console.log("Save ERROR!"),
      });
  }

  onAddBranch() {
    const branch = new Branch();
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: branch,
    });
    dialogRef.afterClosed().subscribe(async (data: Branch) => {
      if (data != null) {
        data.areas = [];
        this.saveBranchToApi(data);
      }
    });
  }

  updateBranch(b: Branch) {
    const branch = new Branch();
    Object.assign(branch, b);
    const dialogRef = this.dialog.open(BranchEditDialogComponent, {
      width: "20vw",
      data: branch,
    });
    dialogRef.afterClosed().subscribe(async (data: Branch) => {
      if (data != null) {
        this.saveBranchToApi(data);
      }
    });
  }

  deleteArea(branch: Branch, i: number) {
    const dialogData = new ConfirmDialogModel(
      CONFIRM_DIALOG_CONFIRM_ACTION + "  " + branch.name,
      CONFIRM_DIALOG_AREA_DELETE + "   " + branch.areas[i].name,
      ConfDialogType.CONFIRM,
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        branch.areas.splice(i, 1);
        console.log("Deleting area", branch);
        this.saveBranchToApi(branch);
      }
    });
  }

  addNextArea(branch: Branch) {
    const origBranch = branch;
    const availableAreas = this.areas.filter(
      (ar) => branch.areas.findIndex((as) => as.uuid === ar.uuid) === -1,
    );
    const dialogRef = this.dialog.open(BranchesAreasEditComponent, {
      width: "20vw",
      data: availableAreas,
    });
    dialogRef.afterClosed().subscribe(async (data: Area) => {
      if (data != null) {
        origBranch.areas.push(data);
        console.log("Updated area", data);
        this.saveBranchToApi(branch);
      }
    });
  }

  deleteBranch(branch: Branch) {
    console.log("Delete branch by database admin");
  }

  protected readonly ProductCategoriesAtt = ProductCategoriesAttributes;
}
